import { type TOC } from '@ember/component/template-only';
import type { WithBoundArgs as WBA } from '@glint/template';
import type Patient from 'parog-web/models/patient';
import TreatmentsSection from './treatments-section';

interface Signature {
  Args: {
    patient: Patient;
  };
  Blocks: {
    default: [WBA<typeof TreatmentsSection, 'codes'>];
  };
}

const codes = (patient: Patient) => {
  return !!patient.followUpReason &&
    [
      'nephro-transplant',
      'cardio-heart-failure',
      'pneumo-transplant',
      'hepato-transplant',
      'cardio-transplant',
      'onco-ovarian-cancer',
      'onco-pancreatic-cancer',
      'onco-testicular-cancer',
      'onco-prostate-cancer',
      'onco-lymphoma-cancer',
      'onco-stomach-cancer',
      'onco-myeloma-cancer',
      'nephro-mrc',
      'onco-kidney-cancer',
      'onco-hemato-cancer',
      'onco-lung-cancer',
      'onco-cervix-cancer',
      'onco-breast-cancer',
      'onco-breast-cancer-tnm0',
      'onco-liver-cancer',
      'onco-skin-cancer',
      'onco-colon-cancer',
      'onco-brain-cancer'
    ].includes(patient.followUpReason)
    ? ['B03X']
    : [];
};

const TreatmentsFields: TOC<Signature> = <template>
  {{#let (codes @patient) as |codes|}}
    {{#if codes.length}}
      {{yield (component TreatmentsSection codes=codes)}}
    {{/if}}
  {{/let}}
</template>;

export default TreatmentsFields;
